import $ from "jquery";
function isMaterialWp() {
    return $("body").hasClass("material-wp");
}
function materialWpWidthRules(calc) {
    return `width: -webkit-calc(${calc}) !important;` + `width: -moz-calc(${calc}) !important;` + `width: calc(${calc}) !important;`;
}
function materialWpResizeOpposite(containerId, oppositeId, width, injectStyle) {
    const adminBarWidth = $("#adminmenu").width() ?? 0;
    return injectStyle(`${containerId}-styleOpposite`, `@media only screen and (min-width: 1224px) {
            body:not(.wp-customizer) #${oppositeId} {
                ${materialWpWidthRules(`100% - ${width}px - ${adminBarWidth + 20}px`)}
            }
        }
        @media only screen and (max-width: 1223px) and (min-width: 990px) {
            body:not(.wp-customizer) #${oppositeId} {
                ${materialWpWidthRules(`100% - ${width}px - ${adminBarWidth + 40}px`)}
            }
        }
        @media only screen and (min-width: 700px) {
          body.material-wp.activate-aiot .rml-container {
            margin-left: ${adminBarWidth + 20}px;
          }
        }
        @media only screen and (max-width: 1223px) {
          body.material-wp.activate-aiot .rml-container {
            margin-left: ${adminBarWidth + 40}px;
          }
        }
        body #wpcontent #wpbody #${oppositeId}.mwp-expanded {
            ${materialWpWidthRules(`100% - ${width}px - 50px`)}
        }`);
}
export { isMaterialWp, materialWpResizeOpposite };
